import { store } from '@utils/configStore'
import customerQuestionReducer from './slices'

export const injectCustomerQuestion = () => store.injectReducer('customerQuestion', customerQuestionReducer)
